import React from "react";
import Icon1 from "@assets/icons/Icon";

/**
 * Non-blocking visual overlay marking a day as an org closure day ("Fermé").
 * Render inside a `position: relative` day column / grid body. It sits above the
 * grid lines but below appointment/block cards (low z-index) and ignores pointer
 * events, so staff can still interact with the planning underneath if needed.
 */
export function ClosedDayOverlay({ label = "Fermé" }: { label?: string }) {
  return (
    <div
      className="absolute inset-0 pointer-events-none flex items-start justify-center"
      style={{
        zIndex: 15,
        background:
          "repeating-linear-gradient(45deg, rgba(220,38,38,0.05) 0 10px, rgba(220,38,38,0.11) 10px 20px)",
      }}
    >
      <div
        className="mt-2 flex items-center gap-1 px-2 py-1 rounded-md shadow-sm"
        style={{ background: "#FEE2E2", border: "1px solid #FECACA" }}
      >
        <Icon1 name="lock" size={11} color="#DC2626" />
        <span className="text-h5 font-semibold" style={{ color: "#DC2626", fontFamily: "Poppins" }}>
          {label}
        </span>
      </div>
    </div>
  );
}
